import { __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import { ScrollManager } from '../App/ScrollManager';
import { ScrollContext } from './ScrollContext';
import ScrollingSection from './ScrollingSection';
export default function PageScroll(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const [scrollManager, setScrollManager] = useState(null);
    useEffect(() => {
        if (!scrollManager) {
            setScrollManager(new ScrollManager());
        }
    }, [scrollManager]);
    return (React.createElement(ScrollContext.Provider, { value: { scrollManager, scrollContext: true } },
        React.createElement(ScrollingSection, Object.assign({}, props, { scrollEnabled: true, isRoot: true }), children)));
}
